import lazy from '../utils/lazy';

export const LoginPage = lazy(() =>
  import(/* webChunkName: "LoginPage" */ '../pages/Login/Login')
);

export const HomePage = lazy(() =>
  import(/* webChunkName: "HomePage" */ '../pages/Home')
);

export const NewPasswordPage = lazy(() =>
  import(
    /* webChunkName: "NewPasswordPage" */ '../pages/NewPassword/NewPassword'
  )
);

export const BabyPage = lazy(() =>
  import(/* webChunkName: "BabyPage" */ '../pages/Baby')
);

export const BirthClubPage = lazy(() =>
  import(
    /* webChunkName: "BirthClubPage" */ '../pages/Community/components/BirthClub'
  )
);

export const BabyBlogPage = lazy(() =>
  import(
    /* webChunkName: "BabyBlogPage" */ '../pages/Baby/components/Topics/components/TopicBlog'
  )
);

export const BabyNamesPage = lazy(() =>
  import(/* webChunkName: "BabyNamesPage" */ '../pages/Baby/components/Names')
);

export const GrowthTrackerPage = lazy(() =>
  import(
    /* webChunkName: "GrowthTrackerPage" */ '../pages/Baby/components/GrowthTracker'
  )
);

export const RegistryChecklistPage = lazy(() =>
  import(
    /* webChunkName: "RegistryChecklistPage" */ '../pages/Baby/components/Registry'
  )
);
export const RegistryBuilderPage = lazy(() =>
  import(
    /* webChunkName: "RegistryBuilderPage" */ '../pages/Baby/components/Registry/component/Builder'
  )
);

export const ParentHoodPage = lazy(() =>
  import(/* webChunkName: "ParentHoodPage" */ '../pages/ParentHood')
);

export const PregnancyPage = lazy(() =>
  import(/* webChunkName: "PregnancyPage" */ '../pages/Pregnancy')
);

export const CommunityPage = lazy(() =>
  import(/* webChunkName: "CommunityPage" */ '../pages/Community')
);
export const CommunityBlogPage = lazy(() =>
  import(/* webChunkName: "CommunityBlogPage" */ '../pages/Community/components/Blog')
);
export const CommunityBirthClubPage = lazy(() =>
  import(/* webChunkName: "CommunityBirthClubPage" */ '../pages/Community/components/BirthClub')
);

export const FamilyPage = lazy(() =>
  import(/* webChunkName: "FamilyPage" */ '../pages/Family')
);

export const OvulationTrackerPage = lazy(() =>
  import(
    /* webChunkName: "OvulationTrackerPage" */ '../pages/Family/OvulationTracker'
  )
);

export const DueDateCalculatorPage = lazy(() =>
  import(
    /* webChunkName: "DueDateCalculatorPage" */ '../pages/Pregnancy/DueDateCalculator'
  )
);

// export const CoursesPage = lazy(() =>
//   import(
//     /* webChunkName: "CoursesPage" */ '../pages/Courses'
//   )
// );

// export const CourseDetailPage = lazy(() =>
//   import(/* webChunkName: "CourseDetailPage" */ '../pages/Courses/CourseDetail')
// );

// export const ViewCoursePage = lazy(() =>
//   import(/* webChunkName: "ViewCoursePage" */ '../pages/Courses/ViewCourse')
// );

// export const MyCoursesPage = lazy(() =>
//   import(/* webChunkName: "MyCoursesPage" */ '../pages/Courses/MyCourses')
// );

export const SettingPage = lazy(() =>
  import(/* webChunkName: "SettingPage" */ '../pages/Setting')
);

export const ContactUsPage = lazy(() =>
  import(/* webChunkName: "ContactUsPage" */ '../pages/ContactUs')
);
export const ReportPage = lazy(() =>
  import(/* webChunkName: "ReportPostPage" */ '../pages//Report')
);

export const AboutUsPage = lazy(() =>
  import(/* webChunkName: "AboutUsPage" */ '../pages/AboutUs')
);
export const PrivacyPolicy = lazy(() =>
  import(/* webChunkName: "PrivacyPolicy" */ '../pages/PrivacyPolicy')
);

export const SearchPage = lazy(() => 
  import(/* webChunkName: "AboutUsPage" */'../pages/search/Search'));

export const OvulationPage = lazy(() => 
  import(/* webChunkName: "AboutUsPage" */'../pages/Family/OvulationTracker'));

export const PaymentPage = lazy(() => 
  import(/* webChunkName: "AboutUsPage" */'../pages/Courses/CourseDetail/components/PaymentSection'));


export const TermsOfUse = lazy(() => 
  import(/* webChunkName: "AboutUsPage" */'../pages/TermsUse'));

export const MobileApp = lazy(() => 
  import(/* webChunkName: "AboutUsPage" */'../pages/MobileApp'));

export const CreateGroup = lazy(()=> 
  import ('../pages/Community/components/CreateGroup')
)

export const GroupDetail = lazy(()=>
import('../pages/Community/components/GroupDetail'))

export const ArticlesTopics = lazy(()=>
  import('../pages/Articles/index'))

export const SavedNames = lazy(()=>
  import('../pages/SavedNames'))

export const Blogs = lazy(()=>
  import('../pages/Blogs')) 

export const TopicBlog = lazy(()=>
  import('../pages/Blogs/TopicBlog'))  

export const DeactiveAccountPage = lazy(()=>
  import('../pages/Login/DeactiveAccount')) 
export const CoursesInfo=lazy(()=>
  import('../pages/Courses/CoursesInfo')
)